var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            visible: _vm.dialogVisible,
            title: _vm.$t("data.transfer"),
            width: "735px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleDialogClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "diglog-container" },
            [
              _c("div", { staticClass: "header-line" }),
              _c("div", { staticClass: "section-title" }, [
                _vm._v(" " + _vm._s(_vm.$t("data.transfer_details")) + " "),
              ]),
              _c("div", { staticClass: "section-tip" }, [
                _vm._v(" " + _vm._s(_vm.$t("tips.transfert_enter")) + " "),
              ]),
              _c(
                "el-form",
                {
                  ref: "transForm",
                  attrs: {
                    model: _vm.transForm,
                    "status-icon": "",
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("data.sender") } },
                            [
                              _c("div", { staticClass: "input-show-info" }, [
                                _vm._v(_vm._s(_vm.$store.getters.mainUserName)),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 11, offset: 2 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "merchantAccount.current_balance"
                                ),
                              },
                            },
                            [
                              _c("div", { staticClass: "input-show-info" }, [
                                _vm._v(
                                  _vm._s(_vm.$store.getters.currency) +
                                    " " +
                                    _vm._s(
                                      _vm._f("toDivideWithDot")(_vm.balance)
                                    )
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("data.receiver"),
                                prop: "merchant_id",
                                required: "",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "select-item",
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "data.related_merchants"
                                    ),
                                    clearable: "",
                                  },
                                  on: { change: _vm.onChangeRelatedMch },
                                  model: {
                                    value: _vm.transForm.merchant_id,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.transForm,
                                        "merchant_id",
                                        $$v
                                      )
                                    },
                                    expression: "transForm.merchant_id",
                                  },
                                },
                                _vm._l(
                                  _vm.relatedMerchantsList,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label:
                                          item.merchant_name +
                                          "-" +
                                          item.merchant_no,
                                        value: item.id,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 11, offset: 2 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "merchantAccount.current_balance"
                                ),
                              },
                            },
                            [
                              _c("div", { staticClass: "input-show-info" }, [
                                _vm._v(
                                  _vm._s(_vm.$store.getters.currency) +
                                    " " +
                                    _vm._s(
                                      _vm._f("toDivideWithDot")(
                                        _vm.checkedRelateMch.balance
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("data.transfer_amount") + ":",
                        prop: "amount",
                        rules: [
                          {
                            required: true,
                            message: "Amount cannot be empty",
                            trigger: "blur",
                          },
                          { validator: _vm.checkAmount, trigger: "blur" },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          autocomplete: "off",
                          placeholder: "Enter amount",
                        },
                        model: {
                          value: _vm.transForm.amount,
                          callback: function ($$v) {
                            _vm.$set(_vm.transForm, "amount", $$v)
                          },
                          expression: "transForm.amount",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("data.remark") } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          autocomplete: "off",
                          placeholder: "Enter your message here",
                        },
                        model: {
                          value: _vm.transForm.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.transForm, "remark", $$v)
                          },
                          expression: "transForm.remark",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.$store.getters.isOpenMfa
                    ? _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "450px" },
                          attrs: {
                            label: _vm.$t("system.mfa_verify_code") + ":",
                            prop: "mfa_code",
                            required: "",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "search-frame",
                            attrs: {
                              placeholder: "Enter your MFA verification code",
                              maxlength: "6",
                              autocomplete: "off",
                            },
                            model: {
                              value: _vm.transForm.mfa_code,
                              callback: function ($$v) {
                                _vm.$set(_vm.transForm, "mfa_code", $$v)
                              },
                              expression: "transForm.mfa_code",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-submit",
                  attrs: { type: "info", disabled: _vm.submiting },
                  on: { click: _vm.onClickSubmitBtn },
                },
                [_vm._v(_vm._s(_vm.$t("components.submit")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }